import { topicCollections } from '@/mocks/news';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function TopicSection() {
  return (
    <section id="topic" className="w-full bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto py-12 md:py-16">
          <SectionHeading
            id="topic"
            kicker="专题合集"
            title="把一条线追到底的专题"
            desc="同一件事的物料、回应和后续都收进一个合集，黑料网1更新页负责把碎片时间顺序接上。"
            actionHref="#index"
            actionLabel="全部索引"
          />

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {topicCollections.map((topic) => (
              <article
                key={topic.id}
                className="group rounded-xl overflow-hidden bg-background-100 border border-background-200 hover:border-secondary-300 transition-colors"
              >
                <a href="#topic" className="block cursor-pointer">
                  <div className="w-full aspect-[3/2] overflow-hidden">
                    <img
                      src={topic.image}
                      alt={`黑料网1专题合集：${topic.name}`}
                      title={`${topic.name} - 黑料网1专题`}
                      className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
                    />
                  </div>
                </a>
                <div className="p-4">
                  <div className="flex items-center justify-between">
                    <h5 className="font-heading text-base font-bold text-foreground-950 group-hover:text-secondary-700 transition-colors">
                      <a href="#topic" className="cursor-pointer">
                        {topic.name}
                      </a>
                    </h5>
                    <span className="inline-flex items-center h-6 px-2 rounded-full bg-secondary-100 text-secondary-900 text-[11px]">
                      {topic.count} 条
                    </span>
                  </div>
                  <p className="mt-2 text-xs text-foreground-600 leading-relaxed">{topic.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}